import type { AxiosResponse } from "axios"
import qs from "qs"

import type { v1FetchChatResponse } from "@be-miniapp/types"

import { httpPost } from "../http"

export interface V1PostChatParams {
  engagement_id: string
  message: string
  service_type: number
}

export function v1PostChat(
  params: V1PostChatParams,
  options?: { formUrlEncoded?: boolean }
): Promise<AxiosResponse<any>> {
  const isForm = Boolean(options?.formUrlEncoded)
  const data = isForm ? qs.stringify(params) : params
  const headers = isForm
    ? { "Content-Type": "application/x-www-form-urlencoded", Charset: "UTF-8" }
    : { "Content-Type": "application/json", Charset: "UTF-8" }

  return httpPost("be-chat/chat/v1/post_chat", data, { headers })
}

export interface V1FetchChatParams {
  engagement_id: string
  service_type: number
  login_type: number
}

export function v1FetchChat(
  params: V1FetchChatParams,
  options?: { formUrlEncoded?: boolean }
): Promise<AxiosResponse<v1FetchChatResponse>> {
  const isForm = Boolean(options?.formUrlEncoded)
  const data = isForm ? qs.stringify(params) : params
  const headers = isForm
    ? { "Content-Type": "application/x-www-form-urlencoded" }
    : { "Content-Type": "application/json" }

  return httpPost<v1FetchChatResponse>("be-chat/chat/v1/fetch_chat", data, {
    headers,
  })
}
